import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { genericBaseUrl } from './utils';
import { Statistics } from '$synapse/models';

@Injectable({
  providedIn: 'root',
})
export class StatsService {
  private readonly _http = inject(HttpClient);

  private _baseUrl(...path: any[]): string {
    return genericBaseUrl(
      `${environment.settings.api.url}/manager/stats`,
      ...path
    );
  }

  getStats(assessmentId: string): Observable<Statistics> {
    return this._http.get<Statistics>(this._baseUrl(assessmentId));
  }

  getGroupStats(groupId: string): Observable<Statistics> {
    return this._http.get<Statistics>(this._baseUrl('group', groupId));
  }

  downloadGroupAssessmentStatsReport(
    groupAssessmentId: string
  ): Observable<Blob> {
    return this._http.get(
      this._baseUrl('export/group-assessment', groupAssessmentId),
      { responseType: 'blob' }
    );
  }

  downloadAssessmentStatsReport(assessmentId: string): Observable<Blob> {
    return this._http.get(this._baseUrl('export/assessment', assessmentId), {
      responseType: 'blob',
    });
  }

  downloadCandidateAssessmentStats(): Observable<Blob> {
    return this._http.get(this._baseUrl(`export/candidate-assessment`), {
      responseType: 'blob',
    });
  }
}
